module.exports = __webpack_public_path__ + "img/849.8dc318d5.png";